'use client'

import React from 'react'

import { chakra } from '@chakra-ui/react'

import { CloseIcon } from '../Icon/CloseIcon'
import {
  ChipVariant,
  ColorScheme,
  chipStyles,
  dismissButtonStyles,
} from './Chip.styles'

export type { ColorScheme, ChipVariant }

export type ChipProps = {
  label: string
  variant?: ChipVariant
  colorScheme?: ColorScheme
  /** When provided, renders a dismiss button (×) inside the chip. */
  onDismiss?: () => void
  /** The dismiss button's accessible name, e.g. "Remove panel@x.com". */
  dismissLabel?: string
}

export const Chip = ({
  label,
  variant = 'field',
  colorScheme = 'dark',
  onDismiss,
  dismissLabel = 'Remove',
}: ChipProps) => (
  <chakra.span {...chipStyles(variant, colorScheme)}>
    {label}
    {onDismiss != null && (
      <chakra.button
        aria-label={dismissLabel}
        onClick={(e) => {
          e.stopPropagation()
          onDismiss()
        }}
        type='button'
        {...dismissButtonStyles(colorScheme)}
      >
        <CloseIcon colorScheme={colorScheme} size={10} />
      </chakra.button>
    )}
  </chakra.span>
)
